import { render, staticRenderFns } from "./WorkflowTransitionForm.vue?vue&type=template&id=6e718928&"
import script from "./WorkflowTransitionForm.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTransitionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports